export const LT_ACTIVITIES_SAVED = 'LT_ACTIVITIES_SAVED'
export const LT_ACTIVITIES_SAVE_FAILED = 'LT_LIFESTYLE_EXPENSE_SAVE_FAILED'
export const LT_ACTIVITIES_DELETED = 'LT_ACTIVITIES_DELETED'
export const LT_ACTIVITIES_RECIEVED = 'LT_ACTIVITIES_RECIEVED'
export const LT_ACTIVITIES_RECEIVE_FAILED = 'LT_LIFESTYLE_EXPENSE_RECEIVE_FAILED'
export const LT_ACTIVITIES_UNLOADED = 'LT_ACTIVITIES_UNLOADED'